const Vec3Up = { x: 0, y: 1, z: 0 };

export { Vec3Up };
//# sourceMappingURL=vec3-up.js.map
